import CityPagePersianas from "../components/CityPagePersianas";

export default function PersianasVelezMalaga() {
  return (
    <CityPagePersianas
      name="Vélez-Málaga"
      slug="velez-malaga"
      cp="29700"
      poblacion={87798}
      zonaGeo="Axarquía"
      lat={36.7798}
      lng={-4.1027}
      zonas={[
        "Vélez Centro",
        "Torre del Mar",
        "Caleta de Vélez",
        "Benajarafe",
        "Almayate",
      ]}
      landmarks={[
        "Fortaleza de Vélez",
        "Plaza de la Constitución",
        "Torre del Mar",
      ]}
      municipiosLimitrofes={[
        "Algarrobo",
        "Torrox",
        "Benamargosa",
        "Macharaviaya",
      ]}
      festivalLocal="Real Feria de San Miguel, finales de septiembre"
      contextoTipologico="Capital de la Axarquía, mix casco histórico con persianas tradicionales y zona costera Torre del Mar moderna."
      isCoreZone={false}
    />
  );
}